
import { defineComponent, PropType, ref, computed } from 'vue';
import SelectInput from '@/components/form/parts/fields/SelectInput.vue';
import GamePicker from './GamePicker.vue';

export default defineComponent({
  name: 'GameSelectWithPicker',
  components: { SelectInput, GamePicker },
  props: {
    input: { type: Object as PropType<any>, required: true },
    options: { type: Array as PropType<any[]>, default: () => [] },
    modelValue: { type: [Array, Number, String, null] as PropType<any>, default: null },
    disabled: { type: Boolean, default: false },
    hideSelect: { type: Boolean, default: false },
  },
  emits: ['update:modelValue'],
  setup(props) {
    const open = ref(false);
    const isMultiple = computed(() => props.input?.value === 'multiple');
    return { open, isMultiple };
  },
});
